import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledOrderItem = styled.div`
  background: ${props => props.theme.colors.light};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  display: inline-flex;
  justify-content: space-between;
  min-width: ${rem('79px')};
  padding: ${rem('11px')} ${rem('5.5px')};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('7.5px')} ${rem('5.5px')};
    min-width: ${rem('59px')};
  `};
`;

const ButtonOrder = styled.button`
  background-color: inherit;
  border: 0;
  line-height: 0;
`;

const InputOrder = styled.input`
  background-color: inherit;
  border: 0;
  font-family: ${props => props.theme.fonts.bold};
  max-width: ${rem('25px')};
  text-align: center;
  width: auto;
`;

const OrderIcon = styled(Icon)`
  width: ${rem('10px')};
`;

export { StyledOrderItem, ButtonOrder, InputOrder, OrderIcon };
